import SharedDownloadPage from './SharedDownloadPage';
export default SharedDownloadPage;